<form [formGroup]="form" class="content" name="form">
    <formly-form [fields]="fields" [form]="form" [model]="model"></formly-form>
</form>
